import { Link } from "react-router-dom";
import logo from "../assets/logo-icon.svg";
import { ANDROID_URL, IOS_URL } from "../config/ApiCollection";
import { useState } from "react";
import appstore_download from "../assets/icons/app-store-download.png";
import playtore_download from "../assets/icons/play-store-download.png";
const navLinks = [];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const pathname = "window.location.pathname";

  return (
    <div className="flex justify-center">
      <header className="py-3 my-10 px-4 border border-gray-300 rounded-xl w-[90%] relative z-50">
        <div className="container mx-auto flex items-center justify-between">
          {/* Logo + Brand Name */}
          <Link to="/">
            <div className="flex items-center gap-3">
              <img
                src={logo}
                alt="FastMate Logo"
                className="w-16 h-16 rounded-xl p-2"
              />
              <span className="text-gray-800 font-semibold text-xl">
                FastMate
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8 text-gray-500 font-normal text-lg">
            <Link
              to="/"
              className={`${
                pathname == "/" ? "text-themecolor font-semibold" : ""
              } hover:text-themecolor `}
            >
              Home
            </Link>
            <Link
              to="/manage-subscription"
              className={`${
                pathname == "/manage-subscription"
                  ? "text-themecolor font-semibold "
                  : ""
              } hover:text-themecolor `}
            >
              Manage Subscription
            </Link>
          </nav>

          {/* Download Button (always visible) */}
          <div className="flex justify-end sm:justify-end gap-2 hidden md:flex">
            <a
              href={IOS_URL}
              className="md:w-[148px] w-[30%] bg-black rounded-[10px]"
            >
              <img src={appstore_download} className="rounded-[10px]" />
            </a>
            <a
              href={ANDROID_URL}
              className="md:w-[148px] w-[30%] bg-black rounded-[10px] content-center"
            >
              <img src={playtore_download} className="rounded-[10px]" />
            </a>
          </div>

          {/* Hamburger Icon (Mobile only) */}
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden text-gray-600 focus:outline-none ml-4"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              {menuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation Dropdown */}
        {menuOpen && (
          <div className="md:hidden mt-4 px-2 space-y-4 text-gray-700 font-medium text-right">
            <Link to="/" onClick={() => setMenuOpen(false)} className="block">
              Home
            </Link>
            <Link
              to="/manage-subscription"
              onClick={() => setMenuOpen(false)}
              className="block"
            >
              Manage Subscription
            </Link>
            <div className="flex  justify-end sm:justify-center gap-2 ">
              <a
                href={IOS_URL}
                className="md:w-[148px] w-[30%] bg-black rounded-[10px]"
              >
                <img src={appstore_download} className="rounded-[10px]" />
              </a>
              <a
                href={ANDROID_URL}
                className="md:w-[148px] w-[30%] bg-black rounded-[10px] content-center"
              >
                <img src={playtore_download} className="rounded-[10px]" />
              </a>
            </div>
          </div>
        )}
      </header>
    </div>
  );
}
